// extracted by mini-css-extract-plugin
export default {"container":"PromptMessage_container__vI9KA","message":"PromptMessage_message__gTWbR","button_group":"PromptMessage_button_group__AGSXd"};